import { Component, EventEmitter, Inject, OnDestroy, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormGroup, FormArray, FormControl, Validators } from '@angular/forms';
import { BackOfficeService } from '../../../../../services/backoffice.service';
import { Order, TransactionVM } from '../../../../../models/orderModel';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subject } from 'rxjs';
import { takeUntil, debounceTime } from 'rxjs/operators';
import { MatCheckboxChange } from '@angular/material/checkbox';

@Component({
  selector: 'app-back-office24-order-transaction-manager',
  standalone: false,
  templateUrl: './back-office24-order-transaction-manager.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./back-office24-order-transaction-manager.component.css']
})
export class BackOffice24OrderTransactionManagerComponent implements OnInit, OnDestroy {
  transactionForm: FormGroup;
  isSubmitting = false;
  order: Order;
  remainingServices: any[] = [];
  selectedServices: any[] = [];
  componentDestroyed$ = new Subject<boolean>();
  @Output() saveChangesEvent = new EventEmitter<void>();
  extraDays: number;
  insuranceCost: number;

  orderAdditionalServices: any[];

  constructor(
    private fb: FormBuilder,
    private backofficeService: BackOfficeService,
    private snackBar: MatSnackBar,
    public dialogRef: MatDialogRef<BackOffice24OrderTransactionManagerComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {
      order: Order,
      orderAdditionalServices: any[],
      allAdditionalServices: any[]
    }
  ) {
    this.order = data.order;
  }

  ngOnInit(): void {
    this.initializeForm();
    this.loadRemainingServices();
    // this.setupFormListeners();
  }

  ngOnDestroy(): void {
    this.componentDestroyed$.next(true);
    this.componentDestroyed$.complete();
  }

  private initializeForm(): void {
    this.transactionForm = this.fb.group({
      // Additional services
      extraDaysproductId: ['50A5DB0B-3935-440D-9603-35C679B311E0'],
      extraDays: [this.extraDays || 0, [Validators.min(0)]],
      insuranceProductId: ['50A5DB0B-3935-440D-9603-35C679B311E0'],
      insuranceCost: [this.insuranceCost || 0, [Validators.min(0)]],
      selectedServices: this.fb.array([])
    });
  }


  private loadRemainingServices(): void {

    if (!this.data.allAdditionalServices || !this.data.orderAdditionalServices) {
      return;
    }

    const existingServiceNames = new Set(
      this.data.orderAdditionalServices.map(service => {
        if(service.status !== 'Cancelled' && service.status !== 'Removed')
          return service.name
      })
    );

    this.remainingServices = this.data.allAdditionalServices.filter(
      service => !existingServiceNames.has(service.name)
    );

    this.orderAdditionalServices = this.data.allAdditionalServices.filter(
      service => existingServiceNames.has(service.name)
    );
  }

  onServiceSelectionChange(event: MatCheckboxChange, service: any): void {
    const selectedServices = this.transactionForm.get('selectedServices') as FormArray;
    if (event) {
      const index = this.selectedServices.findIndex(s => s.id === service.id);
      if (index >= 0) {
        selectedServices.removeAt(index);
        this.selectedServices.splice(index, 1);
      }else {
        selectedServices.push(new FormControl(service));
        this.selectedServices.push(service);
      }
    }
  }

  onSubmit(): void {
    if (this.transactionForm.invalid) {
      this.snackBar.open('Please fill in all required fields', 'Close', { duration: 3000 });
      return;
    }

    this.isSubmitting = true;
    const formValue = this.transactionForm.getRawValue();

    // Prepare transaction data
    const transactionData = {
      orderId: this.order.orderId,
      extraDays: formValue.extraDays || 0,
      insuranceCost: formValue.insuranceCost || 0,

      selectedServices: formValue.selectedServices?.map(service => ({ id: service.id })) || []
    };

    this.backofficeService.createTransactionWithServices(transactionData).subscribe({
      next: (response) => {
        this.snackBar.open('Transaction and services added successfully', 'Close', { duration: 2000, verticalPosition: 'top' });
        this.saveChangesEvent.emit();
        this.dialogRef.close(true);
      },
      error: (error) => {
        console.error('Error creating transaction:', error);
        this.snackBar.open('Failed to create transaction. Please try again.', 'Close', { duration: 2000, verticalPosition: 'top' });
        this.isSubmitting = false;
    }
    });
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }
}
